import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DotsVerticalIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9233 3.60715C14.0279 3.60715 14.9233 4.50258 14.9233 5.60715C14.9233 6.71172 14.0279 7.60715 12.9233 7.60715C11.8188 7.60715 10.9233 6.71172 10.9233 5.60715C10.9233 4.50258 11.8188 3.60715 12.9233 3.60715ZM12.9233 10.6071C14.0279 10.6071 14.9233 11.5026 14.9233 12.6071C14.9233 13.7117 14.0279 14.6071 12.9233 14.6071C11.8188 14.6071 10.9233 13.7117 10.9233 12.6071C10.9233 11.5026 11.8188 10.6071 12.9233 10.6071ZM12.9233 17.6071C14.0279 17.6071 14.9233 18.5026 14.9233 19.6071C14.9233 20.7117 14.0279 21.6071 12.9233 21.6071C11.8188 21.6071 10.9233 20.7117 10.9233 19.6071C10.9233 18.5026 11.8188 17.6071 12.9233 17.6071Z"
            />
        </SvgIcon>
    );
};

export default DotsVerticalIcon;
